
export const COLOR_PRIMARY = '#007b34';
export const COLOR_SECONDARY = '#f61720';
export const COLOR_INACTIVE = '#dbdbdb';
export const COLOR_BACKGROUND = '#FAFAFA';
